<script>
import SensorVirtualPeriodoNone from '@/components/sensor-virtual/periodo-forms/SensorVirtualPeriodoNone.vue'
import SensorVirtualPeriodoTurno from '@/components/sensor-virtual/periodo-forms/SensorVirtualPeriodoTurno.vue'
import SensorVirtualPeriodoUltimasHoras from '@/components/sensor-virtual/periodo-forms/SensorVirtualPeriodoUltimasHoras.vue'
import { VirtualSensorPeriodoTipo } from '@/utils/constants'

export default {
  name: 'SensorVirtualPeriodo',
  components: {
    SensorVirtualPeriodoUltimasHoras,
    SensorVirtualPeriodoTurno,
    SensorVirtualPeriodoNone,
  },
  props: {
    periodoTipo: {
      type: Number,
      required: true,
    },
    periodoValue: {
      type: Object,
      required: false,
    },
    localId: {
      type: String,
      required: true,
    },
    onlyForm: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      tipos: VirtualSensorPeriodoTipo,
      loading: false,
    }
  },
  methods: {
    emitChange(data) {
      this.$emit('change', data)
    },
  },
}
</script>

<template>
  <div>
    <div v-if="periodoTipo === tipos['None']">
      <SensorVirtualPeriodoNone @change="emitChange" />
    </div>

    <div v-if="periodoTipo === tipos['Turno']">
      <SensorVirtualPeriodoTurno
        :only-form="onlyForm"
        :local-id="localId"
        :data="periodoValue"
        @change="emitChange"
      />
    </div>

    <div v-if="periodoTipo === tipos['UltimasHoras']">
      <SensorVirtualPeriodoUltimasHoras
        :data="periodoValue"
        @change="emitChange"
      />
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
